<template>
  <div style="padding: 0 15px;">
    <el-form ref="channelPostForm" :model="postForm" label-position="left" label-width="105px">
      <el-form-item label="选择校区">
        <Select key="6" :selected.sync="postForm.new_team_id" :data="selectLists" placeholder="请选择" />
      </el-form-item>
      <el-button type="primary" @click="createData"> 保存 </el-button>
    </el-form>
  </div>
</template>

<script>

const defualtPostForm = {
  item_id: '',
  new_team_id: '',
  old_team_id: ''
}

import Select from '@/components/Select'

export default {
  name: 'ConvertComboGroup',
  components: {
    Select
  },
  props: {
    item: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    }

  },
  data() {
    return {
      postForm: {},
      selectLists: []
    }
  },
  watch: {

  },
  created() {
    // this.postForm.shop_id = this.shopId
    this.postForm = Object.assign(defualtPostForm, this.item)
    this.getLists()
  },
  methods: {
    getLists() {
      this.$http.getItemTeamList(this.search).then(res => {
        res.data.list.forEach(function(el) {
          el.id = el.team_id
          el.name = el.team_name
        })
        this.selectLists = res.data.list
      })
    },
    createData() {
      this.$http.moveItemForTeam(this.postForm).then(res => {
        this.$message({
          type: 'success',
          message: '添加成功'
        })
        this.$emit('successCBK')
      })
    }

  }
}
</script>

<style scoped>
  .dialog-footer{
    text-align: right;
  }
</style>
